var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section section--member section--bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v(" 出勤中 ")]),(_vm.recentLives.length <= 0)?_c('p',{staticClass:"notification_text"},[_vm._v("現在、出勤中のキャストはいません。")]):_vm._e(),_c('ul',{staticClass:"columns is-multiline is-mobile"},_vm._l((_vm.recentLives),function(live){return _c('LiveListedTile',{key:live.id,attrs:{"tileData":{
          liveId: live.id,
          imageSrc: live.thumbnailURL,
          nickname: live.performerNickname,
          genre: live.categories,
          startAt: live.startAt,
          title: live.title,
          type: 'recentLive'
        },"onClick":_vm.liveTileClicked}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }